import { unitById } from "@zend/content";
import { portraitUrl } from "../assets/manifest.js";
import { pick, useT } from "../i18n/index.js";
import { Icon } from "../ui/Icon.js";
import type { SquadSlotKey, UnitView } from "./types.js";
import { unitName } from "./shared.js";

/** A formation place is an assignment action; inspection remains a separate touch target. */
export function FormationSeat({ unit, slot, chemistry, onChoose, onInspect }: {
  unit: UnitView; slot: SquadSlotKey; chemistry: number; onChoose: () => void; onInspect: () => void;
}) {
  const t = useT(), def = unitById(unit.unitId);
  return <div className="formation-seat" data-tier={def.tier} data-damaged={unit.hpPct < 100}>
    <button type="button" className="formation-seat-pick" onClick={onChoose} data-testid={`slot-unit-${slot}`}
      aria-label={`${t(`slot.${slot}`)}: ${unitName(unit.unitId)} · ${t(`role.${def.role}`)}`}>
      <span className="formation-seat-rank">{def.tier} <small>Lv {unit.level}{unit.stars > 0 ? ` · ★${unit.stars}` : ""}</small></span>
      <img src={portraitUrl(unit.unitId)} alt="" decoding="async" />
      <strong>{unitName(unit.unitId)}</strong>
      <span className="formation-seat-role">{t(`role.${def.role}`)} · {def.mfr}</span>
    </button>
    <div className="formation-seat-footer">
      <span><b>{unit.repair ? t("units.repairing") : unit.wrecked ? t("units.wrecked") : `HP ${unit.hpPct}%`}</b><small>+{chemistry}% {pick({de:"Chemie",en:"chemistry"})}</small></span>
      <button type="button" className="formation-seat-info" onClick={onInspect} aria-label={t("squad.inspect", { name: unitName(unit.unitId) })}><Icon name="info" /></button>
    </div>
  </div>;
}
